/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { FeedActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        feeds: state.feeds
    });
}

function mapDispatchToProps(dispatch) {

    return {
        feedSearch: (term, locale) => {
            dispatch(FeedActions.feedSearch(term, locale));
        },
        resetFeedSearch: () => {
            dispatch(FeedActions.resetSearch());
        },
        feedValidate: (feed) => {
            dispatch(FeedActions.validateFeed(feed));
        },
        resetFeedValidation: () => {
            dispatch(FeedActions.resetValidation());
        }
	};
}

export default function FeedProvider(Component) {

    class FeedProvider extends React.Component {
        render() {
            return (
                <Component {...this.props}/>
            );
        }
    }

    FeedProvider.displayName = "FeedProvider";

    return connect(mapStateToProps, mapDispatchToProps)(FeedProvider);
};
